// client/extensions/Table.ts
import Table from "@tiptap/extension-table";
import TableCell from "@tiptap/extension-table-cell";
import TableHeader from "@tiptap/extension-table-header";
import TableRow from "@tiptap/extension-table-row";
var TableTranslations = {
  table: {
    tooltip: {
      actionBar: ["Tabelle", "Table"],
      insertTable: ["Tabelle einf\xFCgen", "Insert Table"],
      deleteTable: ["Tabelle l\xF6schen", "Delete Table"],
      insertRowAbove: ["Zeile oben einf\xFCgen", "Insert Row Above"],
      insertRowBelow: ["Zeile unten einf\xFCgen", "Insert Row Below"],
      deleteRow: ["Zeile l\xF6schen", "Delete Row"],
      insertColumnBefore: ["Spalte davor einf\xFCgen", "Insert Column Before"],
      insertColumnAfter: ["Spalte danach einf\xFCgen", "Insert Column After"],
      deleteColumn: ["Spalte l\xF6schen", "Delete Column"]
    }
  }
};
var Tables = {
  styles: ({ host }) => [],
  buttons: ({ editor, host }) => [
    {
      name: "inserTable",
      tooltip: host.translator.translate("tiptap", "table", "tooltip", "insertTable"),
      icon: "table_chart",
      action: () => editor.chain().focus().insertTable({ rows: 3, cols: 3, withHeaderRow: true }).run()
    },
    {
      name: "deleteTable",
      tooltip: host.translator.translate("tiptap", "table", "tooltip", "deleteTable"),
      icon: "delete",
      action: () => editor.chain().focus().deleteTable().run()
    },
    {
      name: "insertRowAbove",
      tooltip: host.translator.translate("tiptap", "table", "tooltip", "insertRowAbove"),
      icon: "add_row_above",
      action: () => editor.chain().focus().addRowBefore().run()
    },
    {
      name: "insertRowBelow",
      tooltip: host.translator.translate("tiptap", "table", "tooltip", "insertRowBelow"),
      icon: "add_row_below",
      action: () => editor.chain().focus().addRowAfter().run()
    },
    {
      name: "deleteRow",
      tooltip: host.translator.translate("tiptap", "table", "tooltip", "deleteRow"),
      icon: "delete",
      action: () => editor.chain().focus().deleteRow().run()
    },
    {
      name: "insertColumnBefore",
      tooltip: host.translator.translate("tiptap", "table", "tooltip", "insertColumnBefore"),
      icon: "add_column_left",
      action: () => editor.chain().focus().addColumnBefore().run()
    },
    {
      name: "insertColumnAfter",
      tooltip: host.translator.translate("tiptap", "table", "tooltip", "insertColumnAfter"),
      icon: "add_column_right",
      action: () => editor.chain().focus().addColumnAfter().run()
    },
    {
      name: "deleteColumn",
      tooltip: host.translator.translate("tiptap", "table", "tooltip", "deleteColumn"),
      icon: "delete",
      action: () => editor.chain().focus().deleteColumn().run()
    }
  ],
  extensions: [
    Table.configure({
      resizable: true
    }),
    TableRow,
    TableHeader,
    TableCell
  ]
};
export {
  TableTranslations,
  Tables
};
